import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const pageLoaderStyle = {
  display: "flex",
  width: "100%",
  height: "100dvh",
  justifyContent: "center",
  alignItems: "center",
};

const PageLoader = () => {
  return (
    <div style={pageLoaderStyle}>
      <div id="pageSplash">
        <main id="top">
          <div className="wrapContent">
            <section id="pLogo">
              <img src="assets/img/logo/logo-white.svg" alt=""/>
              <img className="imgPreload" src="assets/img/ui/ico-preload.svg" alt=""/>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PageLoader;
